import { PAGE_ROUTES } from '../constants/routingConstants'

export const APP_PROMO_EXCLUDED_PATHS = [
  PAGE_ROUTES.WELLNESS_CHECK_IN.DEFAULT,
  PAGE_ROUTES.REGISTER_AUTO,
  PAGE_ROUTES.COMING_SOON_MICROSITE,
]

export const isAppPromoExcludedPath = (pathname: string) =>
  APP_PROMO_EXCLUDED_PATHS.some((excludedPath) => pathname.includes(excludedPath))
